import { render, staticRenderFns } from "./brandEdit.vue?vue&type=template&id=97505264&scoped=true&"
import script from "./brandEdit.vue?vue&type=script&lang=js&"
export * from "./brandEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97505264",
  null
  
)

export default component.exports